"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MSExchange = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.985 1.02h-3.55a1.015 1.015 0 0 0-.719.297L2.335 9.7a1.015 1.015 0 0 0-.298.718v3.551a1.016 1.016 0 0 0 1.015 1.016h3.552a1.014 1.014 0 0 0 .717-.298l8.382-8.382c.19-.19.298-.448.298-.718v-3.55a1.014 1.014 0 0 0-1.016-1.016Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.984 14.984h-3.551c-.27 0-.528-.107-.718-.298L9.018 12.99V9.817a1.815 1.815 0 0 1 1.815-1.815h3.172l1.697 1.697c.19.19.297.449.297.718v3.551a1.015 1.015 0 0 1-1.015 1.016Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.052 1.02h3.552c.269 0 .527.107.717.297L9.02 3.015v3.172a1.815 1.815 0 0 1-1.815 1.815H4.032L2.334 6.304a1.015 1.015 0 0 1-.297-.718v-3.55A1.015 1.015 0 0 1 3.052 1.02Z",
    fill: "#50D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.437 4.607v7.662c0 .04-.003.079-.012.117a.673.673 0 0 1-.666.561H2.037V3.93H7.76a.677.677 0 0 1 .678.678Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.728 4.607v7.08a.978.978 0 0 1-.969.97H2.037V3.637H7.76a.972.972 0 0 1 .969.969Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.437 4.607v7.08a.677.677 0 0 1-.678.679H2.037V3.929H7.76a.677.677 0 0 1 .678.678Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.146 4.607v7.08a.676.676 0 0 1-.678.679h-5.43V3.929h5.43a.677.677 0 0 1 .678.678Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.467 3.93H.679A.679.679 0 0 0 0 4.607v6.788c0 .375.304.678.679.678h6.788a.679.679 0 0 0 .678-.678V4.608a.679.679 0 0 0-.678-.679Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.406 6.513H3.5v1.113H5.29v.714H3.501v1.157h2.006v.71h-2.87V5.797h2.769v.717Z",
    fill: "#fff"
  })));
});
var _default = MSExchange;
exports["default"] = _default;